import React from "react";
import NavbarLanding from "./NavbarLanding";
import { Typography, Button, Box, styled, useTheme, useMediaQuery } from "@mui/material";
import image13 from "../images/image13";
import image14 from "../images/image14";
import image15 from "../images/image15";
import SchoolIcon from "@mui/icons-material/School";
import BlogsSection from "./BlogsSection";
import { useNavigate } from "react-router-dom";

const menuItems = {
    "Who is it for?": ["Students", "Colleges", "Schools"],
    Reports: ["Individual Analysis", "Cohort Analysis"],
    "About Us": null,
    Testimonials: null,
    "Contact Us": null,
};

const PageWrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
});

const Section = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    width: "90%",
    padding: "16px",
    margin: "16px 0",
    height: "auto",
    borderTop: "2px solid #e0e0e0",
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
    },
}));


const HighlightTypography = styled(Typography)(({ theme }) => ({
    fontSize: "1.5rem",
    fontWeight: 700,
    marginBottom: "16px",
    fontFamily: "Poppins, sans-serif",
    [theme.breakpoints.down("sm")]: {
        fontSize: "1.25rem",
    },
}));

const ResponsiveButton = styled(Button)(({ theme }) => ({
    textTransform: "none",
    borderRadius: "16px",
    fontWeight: 600,
    padding: "8px 24px",
    cursor: 'pointer',
    fontFamily: "Poppins, sans-serif",
    transition: "all 0.3s ease",
    "&:hover": {
        backgroundColor: "black",
        color: "white",
    },
    [theme.breakpoints.down("sm")]: {
        padding: "8px 16px",
    },
}));

const Entrypage = () => {
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down("md"));
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();

    const handleAccessReportClick = () => {
        navigate("/accessreport");
    };

    return (
        <PageWrapper>
            <NavbarLanding menuItems={menuItems} />

            {/* Students Section */}
            <Section style={{ flexDirection: "column", textAlign: "center", height: '60vh', }}>
                <Box
                    sx={{
                        backgroundColor: "#047840",
                        borderRadius: 2,
                        padding: "8px 16px",
                        mb: 2,
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 600,
                            color: "white",
                            fontSize: "0.875rem",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Under testing at IIMB Behavioral Labs
                    </Typography>
                </Box>
                <Typography
                    sx={{
                        fontSize: isMobile ? "1.75rem" : "2.5rem",
                        fontWeight: 700,
                        color: "black",
                        mb: 3,
                        textAlign: "center",
                        width: "100%",
                    }}
                >
                    Discover your professional strengths
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: isTablet ? "column" : "row",
                        gap: 2,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <ResponsiveButton
                        variant="contained"
                        sx={{
                            backgroundColor: "#2560cc",
                            color: "white",
                        }}
                        onClick={() => navigate("/login")}
                    >
                        Take Assessment
                    </ResponsiveButton>
                    <ResponsiveButton
                        variant="contained"
                        sx={{
                            backgroundColor: "#48C774",
                            color: "white",
                        }}
                        onClick={handleAccessReportClick}
                    >
                        Access Report
                    </ResponsiveButton>
                </Box>
            </Section>

            {/* Professionals Section */}
            <Section>
                <Box sx={{ width: isTablet ? "100%" : "45%" }}>
                    <HighlightTypography>
                        Strengths analyzer format
                    </HighlightTypography>
                    <Typography
                        sx={{
                            fontSize: "1rem",
                            mb: 2,
                            lineHeight: 1.5,
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        How well have you handled working with a group of people internal to your organization?
                    </Typography>
                    <Box
                        component="img"
                        src={image13}
                        alt="Strengths Analyzer Format"
                        sx={{
                            width: "100%",
                            borderRadius: 2,
                        }}
                    />
                </Box>
                <Box sx={{ width: isTablet ? "100%" : "45%", marginBottom: isTablet ? "16px" : "0" }}>
                    <HighlightTypography>
                        Take the strengths analyzer assessment
                    </HighlightTypography>
                    <Typography
                        sx={{
                            fontSize: "1rem",
                            mb: 2,
                            lineHeight: 1.5,
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Your actions speak louder than your perceptions about yourself! Take account of all your
                        extra-curricular activities and assess your performance across different professional
                        dimensions.
                    </Typography>
                    <ResponsiveButton
                        variant="contained"
                        sx={{
                            backgroundColor: "#f7ca17",
                            color: "black",
                        }}
                        onClick={() => navigate("/login")}
                    >
                        Assess Now
                    </ResponsiveButton>
                </Box>
            </Section>

            {/* Organizations Section */}
            <Section>
                <div style={{ width: isTablet ? "100%" : "45%", textAlign: "center" }}>
                    <img
                        src={image14}
                        alt="Strengths Profile"
                        style={{
                            width: isTablet ? "80%" : "70%",
                            height: "auto",
                            objectFit: "cover",
                            borderRadius: "8px",
                            margin: isTablet ? "0 auto" : "0",
                        }}
                    />
                </div>
                <div style={{ width: isTablet ? "100%" : "45%" }}>
                    <HighlightTypography>
                        Get a detailed strengths & weakness spectrum
                    </HighlightTypography>
                    <Typography
                        style={{
                            fontSize: "1rem",
                            marginBottom: "16px",
                            lineHeight: 1.5,
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        With our Strengths Analysis Report, gain an in-depth understanding of your innate skills,
                        growth opportunities, areas in progress, and key development zones. Use these insights as
                        a powerful anchor to guide your learning and development and navigate confidently toward
                        your dream career.
                    </Typography>
                    <ResponsiveButton
                        variant="contained"
                        style={{
                            backgroundColor: "#f7ca17",
                            color: "black",
                        }}
                        onClick={() => navigate("/login")}
                    >
                        Get your report now
                    </ResponsiveButton>
                </div>
            </Section>

            {/* Individual Analysis Section */}
            <Section >
                <div style={{ width: isTablet ? "100%" : "45%", textAlign: "center" }}>
                    <img
                        src={image15}
                        alt="Individual Analysis"
                        style={{
                            width: isTablet ? "80%" : "70%",
                            height: "auto",
                            objectFit: "cover",
                            borderRadius: "8px",
                            margin: isTablet ? "0 auto" : "0",
                        }}
                    />
                </div>
                <div style={{ width: isTablet ? "100%" : "45%" }}>
                    <HighlightTypography>
                        Gain comprehensive insights into your efforts
                    </HighlightTypography>
                    <Typography
                        style={{
                            fontSize: "1rem",
                            marginBottom: "16px",
                            lineHeight: 1.5,
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Unlock key insights into your personality and strengths with our professional analysis.
                        Boost your resume, showcase your strengths, and confidently ace job interviews to get
                        closer to your dream career!
                    </Typography>
                    <ResponsiveButton
                        variant="contained"
                        style={{
                            backgroundColor: "#f7ca17",
                            color: "black",
                        }}
                        onClick={() => navigate("/login")}
                    >
                        Find your strengths spectrum
                    </ResponsiveButton>
                </div>
            </Section>

            {/* Cohort Analysis Section */}
            <Section>
                <Typography
                    style={{
                        fontSize: "1.5rem",
                        fontWeight: 700,
                        marginBottom: "32px",
                        fontFamily: "Poppins, sans-serif",
                    }}
                >
                    Actionable insights for every stakeholder
                </Typography>
                <div
                    style={{
                        display: "flex",
                        flexDirection: isTablet ? "column" : "row",
                        justifyContent: "space-between",
                        width: "100%",
                        fontFamily: "Poppins, sans-serif",
                    }}
                >
                    <Box
                        id="cohort-analysis"
                        sx={{
                            border: "1px solid black",
                            borderRadius: "16px",
                            padding: "16px",
                            width: isTablet ? "100%" : "45%",
                            marginBottom: isTablet ? "16px" : "0",
                        }}
                    >
                        <SchoolIcon fontSize="large" sx={{ color: "#48C774" }} />
                        <Typography
                            sx={{
                                fontWeight: 600,
                                marginTop: "8px",
                                fontFamily: "Poppins, sans-serif",
                            }}
                        >
                            Cohort Analysis
                        </Typography>
                        <Typography sx={{ fontFamily: "Poppins, sans-serif", marginTop: "8px" }}>
                            Schools & colleges can subscribe to this assessment for all students to understand
                            the strengths distribution of the cohort and take actions to help students improve
                            their skills.
                        </Typography>
                    </Box>
                    <Box
                        id="individual-analysis"
                        sx={{
                            border: "1px solid black",
                            borderRadius: "16px",
                            padding: "16px",
                            width: isTablet ? "100%" : "45%",
                        }}
                    >
                        <SchoolIcon fontSize="large" sx={{ color: "#2560cc" }} />
                        <Typography
                            sx={{
                                fontWeight: 600,
                                marginTop: "8px",
                                fontFamily: "Poppins, sans-serif",
                            }}
                        >
                            Individual Analysis
                        </Typography>
                        <Typography sx={{ fontFamily: "Poppins, sans-serif", marginTop: "8px" }}>
                            Students can gain insights about their demonstrated strengths and navigate their
                            career decisions effectively.
                        </Typography>
                    </Box>
                </div>
            </Section>
            <Section id="testimonials">
                <BlogsSection />
            </Section>

            {/* About Us Section */}
            {/* About Us Section */}
            <Section id="about-us">
                {/* About Us */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        padding: "16px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: 2,
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        marginBottom: "32px",
                    }}
                >
                    <Typography
                        style={{
                            fontSize: 24,
                            fontWeight: 700,
                            marginBottom: 16,
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        About Us
                    </Typography>
                    <Typography
                        style={{
                            fontSize: 16,
                            lineHeight: 1.8,
                            textAlign: "center",
                            fontFamily: "Poppins, sans-serif",
                            marginBottom: 16,
                        }}
                    >
                        Founded by an ISB alumna, VocationIQ draws on over 15+ years of expertise
                        in market research, business development, product development, and consulting.
                        The founder’s diverse professional background and personal career development
                        journey inspired the creation of our Strengths Analyzer Platform.
                    </Typography>
                    <Typography
                        style={{
                            fontSize: 16,
                            lineHeight: 1.8,
                            textAlign: "center",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Unlike traditional behaviour-based analysis, our platform utilizes an innovative
                        application-based strengths assessment methodology, setting a new standard in
                        the industry.
                    </Typography>
                </Box>

                {/* Contact Us */}
                <Box
                    id="contact-us"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        padding: "16px",
                        backgroundColor: "#ffffff",
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <Typography
                        style={{
                            fontSize: 24,
                            fontWeight: 700,
                            marginBottom: 16,
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Contact Us
                    </Typography>
                    <Typography
                        style={{
                            fontSize: 16,
                            lineHeight: 1.8,
                            textAlign: "center",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Sindhu VK
                        <br />
                        Founder, VocationIQ Technologies
                        <br />
                        +91-9844459162
                        <br />
                        Bangalore, India
                    </Typography>
                </Box>
            </Section>

        </PageWrapper>
    );
};

export default Entrypage;
